import React from 'react';

/**
 * PageContainer — constrains and pads page content. Drop a PageHeader and the
 * page body inside it. Use `size` to cap the reading width.
 *
 * Props:
 *   size: 'full' | 'wide' | 'narrow'   — max-width (default 'wide')
 */
const PageContainer = ({ size = 'wide', className = '', children }) => (
  <div className={`ps-page ps-page--${size} ${className}`.trim()}>{children}</div>
);

export default PageContainer;
